// Centralized content & constants
export const TRUST = {
  name: "Hazrat Shahanshah Sufi Sarkar",
  alias: "Habibul Mahboob",
  trust: "Hazrat Shahanshah Sufi Sarkar Charitable Trust",
  tagline: "Solve Life Problems — Find Solace, Healing & Divine Blessings",
  honorific: "YA SARKAR NAWAZ ALLAH\nHAZRAT ABU MUHAMMAD BADE PEER MUHIYYUL SHAH NAWAZ ALLAH QADIR GHOUS-E-RABBANI",
  address: "Mecca Majlis, A-10, Venkatesh Park, Balaji Nagar, Lingali Road, Daund",
  phones: ["+91 96656 23311", "+91 85308 85620"],
  whatsapp: "919665623311", // for wa.me link
  whatsappDisplay: "+91 96656 23311",
  email: "hazratshahanshahsufisarkar@gmail.com",
  socials: {
    facebook: "https://facebook.com/hazratsufi.sarkar",
    twitter: "https://twitter.com/sufihazrat",
    instagram: "https://instagram.com/hazratsufisarkar",
  },
};

export const SARKAR_PHOTOS = {
  blessing: "https://customer-assets.emergentagent.com/job_divine-solace/artifacts/luya87mr_WhatsApp%20Image%202026-05-28%20at%2022.48.54.jpeg",
  seated: "https://customer-assets.emergentagent.com/job_divine-solace/artifacts/2mghkeb2_Gemini_Generated_Image_vk393nvk393nvk39.png",
  greeting: "https://customer-assets.emergentagent.com/job_divine-solace/artifacts/o71jrger_WhatsApp%20Image%202026-05-28%20at%2022.49.21.jpeg",
  standing: "https://customer-assets.emergentagent.com/job_divine-solace/artifacts/hprvclpq_WhatsApp%20Image%202026-05-28%20at%2022.49.23.jpeg",
  quran: "https://customer-assets.emergentagent.com/job_divine-solace/artifacts/zrrdn3hx_WhatsApp%20Image%202026-05-28%20at%2021.42.25.jpeg",
};

export const HERO_FACETS = [
  {
    key: "quran",
    label: "The Devout",
    title: "Hafiz",
    href: "/the-book",
    image: "https://customer-assets.emergentagent.com/job_divine-solace/artifacts/zrrdn3hx_WhatsApp%20Image%202026-05-28%20at%2021.42.25.jpeg",
    placeholder: "HERO_SARKAR_1 — Reading the Quran",
  },
  {
    key: "saint",
    label: "The Saint",
    title: "Wali",
    href: "/about",
    // Local transparent PNG — rendered over a dargah background image below
    image: "/portraits/sarkar_hero.png",
    backdrop: "https://static.prod-images.emergentagent.com/jobs/94b9a04e-65da-4587-aedc-289bb56315d5/images/a31ce9fc6e466ce244c31ca162c89392696a9bdcdeba64e2f8e20f34d60e9f0d.png",
    placeholder: "HERO_SARKAR_2 — The Saint",
  },
  {
    key: "mystic",
    label: "The Mystic",
    title: "Sufi",
    href: "/sufism",
    image: "https://customer-assets.emergentagent.com/job_divine-solace/artifacts/2a84d2e526f5b9e10f075a96a42c14cc8ee8abff682e35a204e5fd2defa11a07.png",
    placeholder: "HERO_SARKAR_2 — The Mystic",
  },
  {
    key: "servant",
    label: "The Servant of Humanity",
    title: "Khadim",
    href: "/services",
    image: "https://images.unsplash.com/photo-1542816417-0983c9c9ad53?auto=format&fit=crop&w=1920&q=80",
    placeholder: "HERO_SARKAR_3 — The Servant of Humanity",
  },
];

export const CALLIGRAPHY_IMG = "https://static.prod-images.emergentagent.com/jobs/94b9a04e-65da-4587-aedc-289bb56315d5/images/2c56dfb546e3c316ed559ca22b01f4dde9cd187c9eac5e07dd628436c60ce26d.png";

export const SUFISM_IMG = {
  lantern: "https://static.prod-images.emergentagent.com/jobs/94b9a04e-65da-4587-aedc-289bb56315d5/images/2a84d2e526f5b9e10f075a96a42c14cc8ee8abff682e35a204e5fd2defa11a07.png",
  whirling: "https://static.prod-images.emergentagent.com/jobs/94b9a04e-65da-4587-aedc-289bb56315d5/images/23e5f8ae497f8d995745222238e2ab30ff680cabc5114b22c07d7f62d52370b2.png",
  whirling2: "https://images.pexels.com/photos/10330563/pexels-photo-10330563.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  { key: "guidance", icon: "Compass", title: "Spiritual Guidance & Counseling", desc: "Solutions to life's problems through faith, compassion, and divine wisdom." },
  { key: "healing", icon: "Sparkles", title: "Prayer & Healing (Barakah)", desc: "Blessings for health, family harmony, and lasting peace of mind." },
  { key: "sufi", icon: "Moon", title: "Sufi Teachings & Initiation", desc: "Gentle guidance for murids walking the path of love and remembrance." },
  { key: "unani", icon: "Leaf", title: "Unani Medicine", desc: "Traditional holistic remedies rooted in centuries of practice." },
  { key: "ayurvedic", icon: "Flower2", title: "Ayurvedic Medicine", desc: "Natural healing aligned with the body's elemental balance." },
  { key: "astrology", icon: "Star", title: "Astrology", desc: "Insight and direction drawn from the science of celestial signs." },
  { key: "charity", icon: "HandHeart", title: "Charitable Support", desc: "Food, clothing, shelter, education, and healthcare for the needy." },
];

export const SUFI_PRACTICES = [
  { title: "Love & Devotion", icon: "Heart", desc: "Love is the key to union with the Divine — the soul's truest prayer." },
  { title: "Muraqaba (Meditation)", icon: "Eye", desc: "Stilling the mind to perceive the gentle whisper of the Beloved." },
  { title: "Dhikr (Remembrance)", icon: "Waves", desc: "Chanting the sacred names invokes the living presence of the Divine." },
  { title: "Sama' & Whirling", icon: "Wind", desc: "The whirling dance — the soul's spiraling journey toward union." },
  { title: "Sufi Literature", icon: "BookOpen", desc: "Rumi, Hafiz, Ibn Arabi, Attar — poets who lit the mystical path." },
  { title: "Tariqas (Orders)", icon: "Network", desc: "Mevlevi, Naqshbandi, Chishti, Qadiri — guiding seekers across centuries." },
];

export const SUFI_QUOTES = [
  { q: "What you seek is seeking you.", a: "Rumi" },
  { q: "I am not this hair, I am not this skin, I am the soul that lives within.", a: "Rumi" },
  { q: "I have learned so much from God that I can no longer call myself a Christian, a Hindu, a Muslim, a Buddhist, a Jew.", a: "Hafiz" },
  { q: "The wound is the place where the Light enters you.", a: "Rumi" },
  { q: "Listen to the reed, how it tells a tale, complaining of separations.", a: "Rumi, Masnavi" },
];

export const TESTIMONIALS = [
  { name: "Imran", location: "Palghar", text: "Sarkar's blessings brought healing and calm to my family." },
  { name: "Ayesha", location: "Kerala", text: "Through his guidance I found peace and purpose." },
  { name: "Rahul", location: "Mumbai", text: "My prayers were answered. I am forever grateful for his grace." },
  { name: "Fatima", location: "Pune", text: "His teachings of love changed how I see the world." },
  { name: "Yusuf", location: "London", text: "Distance is no barrier — his barakah travels. My family found steadiness through his prayers." },
  { name: "Sana", location: "Kerala", text: "The trust's charitable hand reached our village in our darkest hour. Allah bless this work." },
];

export const HOME_TESTIMONIALS = [
  { text: "After years of hardship, his blessings brought peace to our home.", attribution: "A devotee, Maharashtra" },
  { text: "My prayers were answered through Sarkar's grace.", attribution: "A murid, Kerala" },
  { text: "His teachings gave my life direction and calm.", attribution: "A follower, Mumbai" },
];

export const HIGHLIGHTS = [
  { icon: "Compass", title: "Spiritual Guidance", desc: "Wisdom on the path of love and self-realization." },
  { icon: "Sparkles", title: "Healing & Blessings", desc: "Barakah, prayer, and karamat for those in need." },
  { icon: "HandHeart", title: "Charitable Service", desc: "Education, healthcare, food, clothing & shelter." },
  { icon: "Leaf", title: "Holistic Remedies", desc: "Sufism alongside Unani, Ayurveda, and astrology." },
];

export const PLANS = [
  {
    name: "Seeker",
    contribution: "Suggested ₹501",
    tagline: "Begin your journey",
    features: [
      "One guidance session with the trust",
      "A short personalized prayer (dua)",
      "Introductory Sufi reading list",
    ],
    cta: "Choose Seeker",
  },
  {
    name: "Devotee",
    contribution: "Suggested ₹2,100",
    tagline: "Walk with devotion",
    featured: true,
    features: [
      "Three guidance sessions",
      "Unani / Ayurvedic remedy consultation",
      "Follow-up dua and remedy plan",
      "Priority response within 48 hours",
    ],
    cta: "Choose Devotee",
  },
  {
    name: "Murid",
    contribution: "Suggested ₹5,100",
    tagline: "Ongoing spiritual mentorship",
    features: [
      "Continuous spiritual mentorship",
      "Priority booking and private gatherings",
      "Special blessings on urs & sacred nights",
      "Invitation to seva initiatives",
    ],
    cta: "Choose Murid",
  },
];

export const JOURNEY = [
  { year: "10 Rabi'l, 1397 AH", title: "Sacred Birth", desc: "Born in Kerala — embodying divine blessings bestowed by the mercy of Rasool Allah ﷺ." },
  { year: "Age 4", title: "Awakened by a Mother's Prayer", desc: "Inspired from a tender age by his mother's devotion to prayer and remembrance." },
  { year: "Age 9", title: "Entrance to Spirituality", desc: "Began rigorous chillas under the guidance of 11 Kamil Peers." },
  { year: "Youth", title: "Quranic Mastery", desc: "Learned sacred verses from his esteemed grandfather, Abbas Ustad." },
  { year: "Adulthood", title: "Sultan-Ul-Faqr", desc: "Recognized as Shahanshah-e-Qutub — King of Spiritual Poverty." },
  { year: "Present", title: "Charitable Trust", desc: "Founded the Hazrat Shahanshah Sufi Sarkar Charitable Trust uplifting the needy." },
];
